import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, CheckCircle } from 'lucide-react';
export function Contact() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    date: '',
    guests: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch('https://formspree.io/f/xqepdvog', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formState)
      });
      if (response.ok) {
        setIsSubmitted(true);
        setFormState({
          name: '',
          email: '',
          date: '',
          guests: '',
          message: ''
        });
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isSubmitted) {
    return <section id="contact" className="py-24 bg-[#F5F1ED]" data-id="element-33">
        <div className="max-w-3xl mx-auto px-6" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="text-center py-16" data-id="element-35">
            <div className="w-16 h-16 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-36">
              <CheckCircle className="w-8 h-8 text-white" data-id="element-37" />
            </div>
            <h3 className="text-3xl font-bold text-[#2D3748] mb-4" data-id="element-38">
              Thank You!
            </h3>
            <p className="text-[#2D3748]/70 mb-8" data-id="element-39">
              We've received your request and will be in touch shortly.
            </p>
            <button onClick={() => setIsSubmitted(false)} className="px-6 py-3 bg-[#2D3748] text-[#F5F1ED] rounded-full font-medium hover:bg-[#1a202c] transition-all" data-id="element-40">
              Submit Another Request
            </button>
          </motion.div>
        </div>
      </section>;
  }
  return <section id="contact" className="py-24 bg-[#F5F1ED]" data-id="element-41">
      <div className="max-w-3xl mx-auto px-6" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-43">
          <h2 className="text-4xl md:text-5xl font-bold text-[#2D3748] mb-4" data-id="element-44">
            Start Your Morning With Us
          </h2>
          <p className="text-[#2D3748]/70" data-id="element-45">
            Tell us about your event. We'll handle the rest.
          </p>
        </motion.div>

        <motion.form initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} onSubmit={handleSubmit} className="space-y-6" data-id="element-46">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-47">
            <div className="space-y-2" data-id="element-48">
              <label htmlFor="name" className="text-sm font-medium text-[#2D3748]" data-id="element-49">
                Name
              </label>
              <input type="text" id="name" name="name" required className="w-full px-4 py-3 rounded-lg bg-white border border-[#E8E3DD] focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none transition-all" placeholder="Jane Doe" value={formState.name} onChange={e => setFormState({
              ...formState,
              name: e.target.value
            })} data-id="element-50" />
            </div>
            <div className="space-y-2" data-id="element-51">
              <label htmlFor="email" className="text-sm font-medium text-[#2D3748]" data-id="element-52">
                Email
              </label>
              <input type="email" id="email" name="email" required className="w-full px-4 py-3 rounded-lg bg-white border border-[#E8E3DD] focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none transition-all" placeholder="jane@company.com" value={formState.email} onChange={e => setFormState({
              ...formState,
              email: e.target.value
            })} data-id="element-53" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-54">
            <div className="space-y-2" data-id="element-55">
              <label htmlFor="date" className="text-sm font-medium text-[#2D3748]" data-id="element-56">
                Event Date
              </label>
              <input type="date" id="date" name="date" className="w-full px-4 py-3 rounded-lg bg-white border border-[#E8E3DD] focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none transition-all" value={formState.date} onChange={e => setFormState({
              ...formState,
              date: e.target.value
            })} data-id="element-57" />
            </div>
            <div className="space-y-2" data-id="element-58">
              <label htmlFor="guests" className="text-sm font-medium text-[#2D3748]" data-id="element-59">
                Estimated Guests
              </label>
              <input type="number" id="guests" name="guests" className="w-full px-4 py-3 rounded-lg bg-white border border-[#E8E3DD] focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none transition-all" placeholder="25" value={formState.guests} onChange={e => setFormState({
              ...formState,
              guests: e.target.value
            })} data-id="element-60" />
            </div>
          </div>

          <div className="space-y-2" data-id="element-61">
            <label htmlFor="message" className="text-sm font-medium text-[#2D3748]" data-id="element-62">
              Additional Details
            </label>
            <textarea id="message" name="message" rows={4} className="w-full px-4 py-3 rounded-lg bg-white border border-[#E8E3DD] focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none transition-all resize-none" placeholder="Dietary restrictions, specific requests, or questions..." value={formState.message} onChange={e => setFormState({
            ...formState,
            message: e.target.value
          })} data-id="element-63" />
          </div>

          <div className="pt-4" data-id="element-64">
            <button type="submit" disabled={isSubmitting} className="w-full md:w-auto px-8 py-4 bg-[#2D3748] text-[#F5F1ED] rounded-full font-medium hover:bg-[#1a202c] transition-all flex items-center justify-center gap-2 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-65">
              {isSubmitting ? 'Sending...' : 'Request Quote'}
              <Send size={16} data-id="element-66" />
            </button>
          </div>
        </motion.form>
      </div>
    </section>;
}